/**
 * Utility tagging-utility
 * @description Utility for tagging apply links with content from adobe mbox
 * @copyright 2021-3-17
 * @file
 */

/**
 * Tests if a string is a valid Url
 *
 * @param {String} string url string value to test
 * @returns {Boolean} true if valid http or https url, false otherwise
 */
function isValidUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (err) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

/**
 * Tagging Utility class for tagging apply links with COIDs
 *
 * @export
 * @class TaggingUtility
 */
class TaggingUtility {
  /**
   * Creates an instance of TaggingUtility.
   * @param {*} options instantiation options
   */
  constructor(options) {
    this.config = options;
  }

  /**
   * Tags apply links with coid qs params
   *
   * @param {Object} coids object containing id to coid mapping
   * @returns {Boolean} true if taggedd successfully, false otherwise.
   */
  tagLinks(coids) {
    if (!coids || Object.keys(coids).length === 0) return false;
    const failure = Object.keys(coids).some(id => {
      const mappedLinks = [...document.querySelectorAll(`#${id}`)];
      return mappedLinks.some(link => !this.tagFunc(link, coids[id]));
    });
    return !failure;
  }

  /**
   * Base tagging logic and checks
   *
   * @param {HTMLElement} linkEl link element to tag url
   * @param {String} coid QS params to tag with
   * @returns {Boolean} true on success, false on error
   */
  tagFunc(linkEl, coid) {
    const url = linkEl.getAttribute('href');
    const coidString = url.indexOf('?') < 0 ? `?${coid}` : `&${coid}`;
    const taggedUrl = url.concat(coidString);

    // Ensure the resulting url is still valid
    if (!isValidUrl(taggedUrl)) {
      return false;
    }
    linkEl.setAttribute('href', taggedUrl);
    return true;
  }
}
var index = new TaggingUtility();

export { index as default };
